import React from "react";
import { ProfilePopoverProps, MenuItemProps } from "../NavBar/types";
import styles from "./ProfilePopover.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const MenuItem = (props: MenuItemProps) => {
  return (
    <div
      className={cx("menuItem", { "menuItem--disabled": props.disabled })}
      onClick={props.onClick}
      role="menuItem"
    >
      {props.children}
    </div>
  );
};

const ProfilePopover = (props: ProfilePopoverProps) => {
  return (
    <div className={cx("profilePopover")}>
      {props.onProfileClick && (
        <MenuItem onClick={props.onProfileClick}>View Profile</MenuItem>
      )}

      <MenuItem
        disabled={!props.onSignOut}
        onClick={props.onSignOut}
      >
        Sign Out
      </MenuItem>

      {props.version && (
        <>
          <div className={cx("menuDivider")}></div>

          <MenuItem disabled={true}>Version: {props.version}</MenuItem>
        </>
      )}
    </div>
  );
};

export default ProfilePopover;
